import { render, staticRenderFns } from "./DavidMorales.vue?vue&type=template&id=69ce8204&scoped=true"
import script from "./DavidMorales.vue?vue&type=script&lang=js"
export * from "./DavidMorales.vue?vue&type=script&lang=js"
import style0 from "./DavidMorales.vue?vue&type=style&index=0&id=69ce8204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ce8204",
  null
  
)

export default component.exports